export default __webpack_public_path__ + "static/media/GeoffZ.6503e391.JPG";